import { api } from './api';

export interface Permission {
  id: number;
  name: string;
  module: string;
  description: string | null;
  createdAt: string;
}

export interface Role {
  id: number;
  name: string;
  description: string | null;
  createdAt: string;
  updatedAt: string;
  rolePermissions: Array<{
    id: number;
    permissionId: number;
    permission: Permission;
  }>;
}

export const rbacService = {
  getPermissions: async (): Promise<Permission[]> => {
    const response = await api.get<Permission[]>('/permissions');
    return response.data;
  },

  getRoles: async (): Promise<Role[]> => {
    const response = await api.get<Role[]>('/roles');
    return response.data;
  },

  createRole: async (payload: { name: string; description?: string }) => {
    const response = await api.post<Role>('/roles', payload);
    return response.data;
  },

  updateRole: async (
    roleId: number,
    payload: { name?: string; description?: string },
  ) => {
    const response = await api.put<Role>(`/roles/${roleId}`, payload);
    return response.data;
  },

  assignPermissions: async (roleId: number, permissionIds: number[]) => {
    const response = await api.post<Role>(`/roles/${roleId}/permissions`, {
      permissionIds,
    });
    return response.data;
  },
};
